import React, { useRef } from "react";

export default function MrbgScrollFrame({children,properties}){
	const ref = useRef(null);

	const
		handleScroll = (e) => {

		if( !e.ctrlKey ) return;

		const el = ref.current;
		if( !el ) return;

		const tag = e.target.tagName.toLowerCase();
		if(['a','button','input','textarea','select','label'].includes(tag)) return;

		const rect = el.getBoundingClientRect();
		const clickX = e.clientX - rect.left;
		const offset = clickX - el.clientWidth / 2;

		el.scrollBy({ left: offset, behavior: "smooth" });
	},
		handleMouseDown = (e)=>{

			const el = ref.current;
			if( !el ) return;

			const tag = e.target.tagName.toLowerCase();
			if(['a','button','input','textarea','select','label'].includes(tag)) return;

			var
				isDown = true,
				startX = e.pageX - el.offsetLeft,
				scrollLeft = el.scrollLeft;

			el.addEventListener('mouseleave', ()=> isDown = false);
			el.addEventListener('mouseup', ()=> isDown = false);
			el.addEventListener('mousemove', (e) => {
				if( !isDown ) return;
				e.preventDefault();
				const
					x = e.pageX - el.offsetLeft,
					walk = x - startX;
				el.scrollLeft = scrollLeft - walk;
			});
		};

	return (
		<div ref={ref} {...properties} onClick={e=>handleScroll(e)} onMouseDown={e=>handleMouseDown(e)}>
			{children}
		</div>
	);
}
